<template>
  <div :class="[isThemes ? '' : 'boxShow', 'Header']" @click="onClick()">
    <div class="left">
      <img
        src="../../../static/image/Header/logo.png"
        @click.stop="goHome"
        v-if="isThemes"
        alt=""
      />
      <img
        src="../../../static/image/Header/logo2.png"
        @click.stop="goHome"
        v-else
        alt=""
      />
      <el-input
        placeholder="按城市、景点、地址、地标搜索"
        prefix-icon="el-icon-search"
        v-model="keyword"
        @keyup.enter.native="onSearch"
      >
      </el-input>
    </div>
    <div class="right">
      <ul>
        <li
          v-for="(item, index) in navList"
          @click.stop="onIsActive(index)"
          :key="index"
          :class="[isActive == index ? 'active' : '']"
        >
          {{ item.name }}
        </li>
        <div class="codeBox" v-if="isCode">
          <div style="margin-right: 30px">
            <img src="../../../static/image/Header/code.png" alt="" />
            <p>下载手机客户端</p>
          </div>
          <div>
            <img src="../../../static/image/Header/xiaochengxu.png" alt="" />
            <p>扫一扫，打开微信小程序</p>
          </div>
        </div>
        <div class="consultBox" v-if="isConsult">
          <router-link to="/consult">
            <div>资讯</div>
          </router-link>
          <router-link to="/askAQuestion">
            <div>问答</div>
          </router-link>
        </div>
      </ul>
      <!-- <router-link to="/HotelCertification/authentication" v-if="is_landlord ==0"> -->
      <div class="btn" @click="onAuthentication" v-if="is_landlord == 0">
        <img src="../../../static/image/Header/ddh.png" alt="" />
        <span>民宿酒店入驻</span>
      </div>
      <!-- </router-link> -->
      <div class="personal" v-if="isLogin">
        <router-link to="/news" class="msg-icon">
          <img
            src="../../../static/image/Header/msg.png"
            class="msg"
            v-if="isThemes"
            alt=""
          />
          <img
            src="../../../static/image/Header/msg2.png"
            class="msg"
            v-else
            alt=""
          />
          <el-badge :value="unreadMsgNum" class="badge"></el-badge>
        </router-link>
        <router-link to="/personal">
          <div>
            <img :src="udata.avatar" class="tx" alt="" />
          </div>
        </router-link>
      </div>
      <div class="login" v-if="!isLogin">
        <router-link to="/account/login">
          <span>注册</span>
        </router-link>
        <router-link to="/account/login">
          <span>登录</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { userInfo, searchStore,getSystemMessage } from "@/request/api";
import { mapMutations } from "vuex";
export default {
  inject: ["routerRefresh"],
  data() {
    return {
      input: "",
      navList: [
        {
          name: "移动端",
          type: 1,
        },
        {
          name: "民宿酒店",
          type: 2,
          path: "/",
        },
        {
          name: "资讯问答",
          type: 3,
        },
        {
          name: "关于平台",
          type: 4,
          path: "/AboutUs",
        },
      ],
      isLogin: false,
      isCode: false,
      isConsult: false,
      isThemes: true,
      is_landlord: 0,
      keyword: "",
      unreadMsgNum: 0
    };
  },
  computed: {
    isActive: {
      get() {
        return this.$store.state.isActiveData.isActive;
      },
      set() {},
    },
    isActiveShow: {
      get() {
        return this.$store.state.isActiveData.isActiveShow;
      },
      set() {},
    },
  },
  mounted() {
    this.getUserInfo();
    if (this.$route.path == "/") {
      this.isThemes = true;
    } else {
      this.isThemes = false;
    }
    this.getSystemMessage()
  },
  watch: {
    $route(to, from) {
      if (to.path == "/") {
        this.isThemes = true;
      } else {
        this.isThemes = false;
      }
    },
    isActiveShow(newData, oldData) {
      this.ForceUpdate(this.$store.state.isActiveData.isActive);
    },
  },
  methods: {
    ...mapMutations(["getIsActive"]),
    // 获取未读消息
    getSystemMessage(){
      getSystemMessage().then((res) => {
        if(res.data.code == 1){
          this.unreadMsgNum = res.data.data.unread_count;
        }
      });
    },
    goHome() {
      this.$router.push({
        path: "/",
      });
    },
    onAuthentication() {
      if (!this.isLogin) {
        this.$message({
          type: "info",
          offset: 200,
          message: "请先登录！",
        });
      } else {
        this.$router.push({
          path: "/authentication",
        });
      }
    },
    onSearch() {
      if (!this.keyword) {
        this.$message({
          type: "info",
          offset: 200,
          message: "请输入搜索内容！",
        });
        return;
      }
      this.searchStore();
      this.$router.push({
        path: "/list",
        query: { keyword: this.keyword },
      });
      this.routerRefresh();
    },
    searchStore() {
      searchStore({ keyword: this.keyword })
        .then((res) => {
          if (res.data.code == 1) {
            this.searchList();
          }
        })
        .catch((err) => {});
    },
    onClick() {
      this.isConsult = false;
      this.isCode = false;
    },
    getUserInfo() {
      userInfo()
        .then((res) => {
          // console.log(res)
          if (res.data.code == 1) {
            this.isLogin = true;
            this.udata = res.data.data;
            this.is_landlord = this.udata.is_landlord;
          }
        })
        .catch((err) => {});
    },
    onIsActive(i) {
      this.getIsActive(i);
      // this.ForceUpdate(i)
    },
    ForceUpdate(i) {
      if (i == 4) {
        this.$router.push("/personal");
        return;
      }
      if (this.navList[i].type == 1) {
        this.isCode = !this.isCode;
        this.isConsult = false;
      } else if (this.navList[i].type == 3) {
        this.isConsult = !this.isConsult;
        this.isCode = false;
      } else if (this.navList[i].type == 2 || this.navList[i].type == 4) {
        this.isCode = false;
        this.isConsult = false;
        this.$router.push(this.navList[i].path);
      }
    },
    // onMouseover(i){
    //   if (this.navList[i].type == 1) {
    //     this.isCode = true;
    //     this.isConsult = false;
    //   }else if (this.navList[i].type == 3) {
    //     this.isConsult = true;
    //     this.isCode = false;
    //   }
    // },
    // onMouseout(i){
    //   // if (this.navList[i].type == 1) {
    //   //   this.isCode = false;
    //   // }else if (this.navList[i].type == 3) {
    //   //   this.isConsult = false;
    //   // }
    // },
  },
};
</script>

<style  scoped lang="scss">
@import "../../../static/scss/_themes.scss";
.Header .left /deep/ .el-input__inner {
  width: 500px;
}
.Header /deep/ .el-input__inner {
  @include inpColorPrimary($inpColor2);
}
.boxShow {
  box-shadow: 0px 1px 5px 0px rgba(170, 170, 170, 0.3);
}
.Header {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @include bg_colorPrimary($bg_color2);
  // background: rgba(0, 0, 0, 0.15);
  padding: 0 30px;
  .left {
    height: 100px;
    display: flex;
    align-items: center;
    img {
      width: 38px;
      height: 48px;
      margin-right: 30px;
      cursor: pointer;
    }
  }
  .right {
    height: 100px;
    display: flex;
    align-items: center;
    ul {
      height: 100px;
      display: flex;
      align-items: center;
      position: relative;
      li {
        height: 100px;
        margin-right: 40px;
        line-height: 100px;
        box-sizing: border-box;
        font-size: 20px;
        font-weight: bold;
        @include color_primary($font_Color2);
        // color: #ffffff;
        cursor: pointer;
      }
      .active {
        border-bottom: 4px solid #fff;
        @include font_ColorAPrimary($font_Color2);
        @include font_ColorAPrimary2($font_Color2);
      }
      .codeBox {
        padding: 30px;
        background: #fff;
        position: absolute;
        bottom: -240px;
        left: -160px;
        display: flex;
        align-items: center;
        div {
          text-align: center;

          img {
            width: 144px;
            height: 144px;
            margin-bottom: 14px;
          }
          p {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
          }
        }
      }
      .consultBox {
        position: absolute;
        top: 100px;
        left: 180px;
        background: #fff;
        box-shadow: 0px 1px 5px 0px rgba(170, 170, 170, 0.3);
        div:nth-child(1) {
          border-bottom: 1px solid #dcdcdc;
        }
        div {
          width: 150px;
          height: 60px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          line-height: 60px;
          text-align: center;
        }
      }
    }
    .btn {
      width: 180px;
      height: 50px;
      background: #fe4365;
      border-radius: 10px;
      font-size: 20px;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 40px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
    }
    .personal {
      display: flex;
      align-items: center;
      .msg-icon {
        position: relative;
        .badge {
          position: absolute;
          right: 25px;
        }
        .msg {
          width: 29px;
          height: 32px;
          margin-right: 40px;
        }
      }
      .tx {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 30px;
      }
    }
    .login {
      display: flex;
      align-items: center;
      span {
        margin-right: 40px;
        font-size: 20px;
        font-weight: bold;
        @include font_ColorAPrimary($font_Color2);
        @include font_ColorAPrimary2($font_Color2);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header/index.vue